export const isOdd = function (x) {
  return x & 1;
};
export const isEven = function (x) {
  return !(x & 1);
};

export const toBoolean = function (value: unknown) {
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') return value === 1;
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (['true', '1'].includes(normalized)) return true;
    if (['false', '0'].includes(normalized)) return false;
  }

  return false;
};
